module.exports = __webpack_public_path__ + "static/img/237_TO8_1995_og.7e62fd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/237_TO8_1995_og.jpg
// module id = Obpr
// module chunks = 0